import React from 'react';
import { useIntl } from 'react-intl';
import { Empty, Spinner } from '@printdeal/ui-library';
// Hooks
import { useSubmittedDesignCookie } from '../../../../hooks/useSubmittedDesignCookie';
import { useSanitizedOrder } from '../hooks/useOrders';

// Components
import OrderDetailWrapper from './OrderDetailWrapper';
import OrderDetailBreadCrumbs from './OrderDetailBreadCrumbs';

interface OrderDetailPageProps {
  orderId: string;
}

const OrderDetailPage = ({
  orderId,
}: OrderDetailPageProps) => {
  useSubmittedDesignCookie();
  const intl = useIntl();

  // Fetch the data of the order
  const { order, isError } = useSanitizedOrder(orderId, intl.locale, 'order_detail_api_failure');

  // An error occurred while retrieving the order.
  if (isError) {
    return (
      <Empty
        icon="search"
        title={intl.formatMessage({
          id: 'account.orderDetails.noResults.title',
          defaultMessage: 'No order found',
        })}
        description={intl.formatMessage({
          id: 'account.orderDetails.noResults',
          defaultMessage: 'We cannot find your order.',
        })}
      />
    );
  }

  // If the order data is not yet available, show skeleton page
  if (!order) {
    return (
      <>
        <OrderDetailBreadCrumbs />
        <Spinner
          size="lg"
          screenReaderLabel={intl.formatMessage({ id: 'uilib.spinner.loading', defaultMessage: 'Loading...' })}
          className="pd-m-auto pd-block"
        />
      </>
    );
  }

  return (
    <OrderDetailWrapper order={order} />
  );
};

export default OrderDetailPage;
